module.exports = __webpack_public_path__ + "img/H2.fa878a0c.png";